import React from 'react';

export const ThinkingAnimation = () => (
  <div className="flex items-center text-gray-400">
    <span className="animate-pulse">大模型</span>
    <span className="animate-pulse" style={{ animationDelay: '200ms' }}>正</span>
    <span className="animate-pulse" style={{ animationDelay: '300ms' }}>在</span>
    <span className="animate-pulse" style={{ animationDelay: '400ms' }}>思</span>
    <span className="animate-pulse" style={{ animationDelay: '500ms' }}>考</span>
    <span className="animate-pulse" style={{ animationDelay: '600ms' }}>...</span>
  </div>
); 